export default __webpack_public_path__ + "static/media/md-border.30d20193.svg";